/**
 * Hamburger Button
 */
class HamburgerButton {
  /**
   * Constructor Description
   * @param {*} button
   */
  constructor(button) {
    this.button = button;
    this.activeClass = 'is-active';
    this.target = document.querySelector(button.getAttribute('data-target'));
    // this.overlayClass = button.getAttribute('data-overlay-class');
    this.wrapper = document.getElementsByClassName('js-main-wrapper')[0];
    this.isOpened = false;
  }

  /**
   * Initial
   */
  init() {
    /**
     * Overlay Created
     */
    // const overlay = document.createElement('div');
    // overlay.classList.add(this.overlayClass);
    // this.target.parentNode.insertBefore(overlay, this.target.nextSibling);
    // this.overlay = overlay;

    /**
     * Button Click Event
     */
    this.button.addEventListener('click', e => {
      e.preventDefault();
      this.toggle(e);
    });
  }

  /**
   * Open
   */
  open() {
    this.wrapper.classList.add(this.activeClass);
    this.button.classList.add(this.activeClass);
    this.target.classList.add(this.activeClass);
    // this.overlay.classList.add(this.activeClass);
  }

  /**
   * Close
   */
  close() {
    this.wrapper.classList.remove(this.activeClass);
    this.button.classList.remove(this.activeClass);
    this.target.classList.remove(this.activeClass);
    // this.overlay.classList.remove(this.activeClass);
  }

  /**
   * Toggle
   * @param {*} e
   */
  toggle(e) {
    e.preventDefault();
    if (this.isOpened === true) {
      this.close();
      this.isOpened = false;
    } else {
      this.open();
      this.isOpened = true;
    }
  }
}

(() => {
  const hamburgerButtons = document.querySelectorAll('[data-toggle="hamburger"]');
  for (let i = 0; i < hamburgerButtons.length; i++) {
    new HamburgerButton(hamburgerButtons[i]).init();
  }
})();
